export default {
  MEDIA_CONTAINER: 'ws-media-container',
  IMAGE: 'img',
  IFRAME: 'ws-iframe[src]:not([src^="https://www.google.com/maps/embed"])',
};
